export function buildDraftsQuery({
  filters = {},
  ordering,
  selectedTab = "all",
  searchDraftValue = ""
}) {
  const tabFilter = selectedTab !== "all" ? { [selectedTab]: true } : {}
  const searchFilter = searchDraftValue ? { search: searchDraftValue } : {}

  return { ...filters, ordering, ...tabFilter, ...searchFilter }
}
